import { useEffect, useState } from 'react'
import { fcApi }             from '../../sdk/fc.api'
import { foApi }             from '../../sdk/fo.api'
import { fulfillmentApi }    from '../../sdk/fulfillment.api'
import { execApi }           from '../../sdk/exec.api'
import { marketingApi }      from '../../sdk/marketing.api'
import { getShop }           from '../../sdk/shop'
import type { FinanceDashboard, CashPosition, GovernorateBreakdown } from '../../sdk/fc.api'
import type { ForecastSummary }                                       from '../../sdk/fo.api'
import type { FulfillmentIntelligence }                               from '../../sdk/fulfillment.api'
import type { ExecDashboard, ExecComparison }                         from '../../sdk/exec.api'
import type { MarketingIntelligence }                                 from '../../sdk/marketing.api'

export type BccData = {
  dashboard:   FinanceDashboard
  cash:        CashPosition
  forecast:    ForecastSummary
  fulfillment: FulfillmentIntelligence
  exec:        ExecDashboard
  comparison:  ExecComparison
  regional:    GovernorateBreakdown
  marketing:   MarketingIntelligence
}

export type BccState =
  | { status: 'loading' }
  | { status: 'error'; message: string }
  | { status: 'ok'; data: BccData }

export function useBccData(): BccState {
  const shop = getShop()
  const [state, setState] = useState<BccState>({ status: 'loading' })

  useEffect(() => {
    const month = new Date().toISOString().slice(0, 7)

    Promise.all([
      fcApi.getDashboard(shop, month),
      fcApi.getCashPosition(shop),
      foApi.getSummary(shop, month),
      fulfillmentApi.getIntelligence(),
      execApi.getDashboard(shop, 'ceo', 'this_month'),
      execApi.getComparison(shop, 'rolling_14'),
      fcApi.getGovernorateBreakdown(shop, month),
      marketingApi.getIntelligence(shop, month),
    ])
      .then(([dashboard, cash, forecast, fulfillment, exec, comparison, regional, marketing]) => {
        setState({ status: 'ok', data: { dashboard, cash, forecast, fulfillment, exec, comparison, regional, marketing } })
      })
      .catch(err => {
        setState({
          status:  'error',
          message: err instanceof Error ? err.message : 'Failed to load dashboard data',
        })
      })
  }, [shop])

  return state
}
